import { Injectable } from "@angular/core";
import { BackNativeService } from '../comunicator-native/back-native/back-native';
import { CacheService } from "../comunicator-native/cache/v2/cache.service";
import { LogService } from "../log/log.service";
import { JourneyTrack } from './tracks/journey-track';
import { JourneyTrackFactoryService } from "./tracks/journey-track-factory.service";
import { TrackInfo } from './tracks/model/track-info';
import { TrackTypes } from './tracks/model/track-types';

@Injectable({
    providedIn: 'root'
})
export class JourneyService {

    public isDataLoading = false;
    public isDataLoaded = false;
    public isDataLoadedError = false;

    public journey: string;
    public edit = false;
    public selectedTrack: JourneyTrack;
    public registratioJourney: any;

    constructor(private cacheNativeService: CacheService,
        private cacheService: CacheService,
        private logService: LogService,
        private journeyTrackFactoryService: JourneyTrackFactoryService,
        public backNativeService: BackNativeService
    ) { }

    private turnLoadingOn() {
        this.isDataLoading = true;
        this.isDataLoaded = false;
        this.isDataLoadedError = false;
    }
    private turnLoadingOff(hasError: boolean) {
        this.isDataLoading = false;
        this.isDataLoaded = false;
        this.isDataLoadedError = hasError;
    }

    public async setTrack(trackType: TrackTypes, typeData?): Promise<void> {

        this.turnLoadingOn();

        this.journey = trackType;

        try {
            this.logService.save('creating instance track', 'JourneyService.setTrack')
            this.selectedTrack = await this.journeyTrackFactoryService.create(trackType, typeData);
            this.logService.save('selectedTrack: ' + this.selectedTrack.getName(), 'JourneyService.setTrack')

            this.registratioJourney = await this.selectedTrack.loadData(this.cacheService);

            this.logService.save('data Loaded ', 'JourneyService.setTrack')

            this.turnLoadingOff(false);
        }
        catch (err) {
            this.logService.save('erro loading data: ' + err.message, 'JourneyService.setTrack')
            return Promise.reject(err?.message);
        }

        this.isDataLoading = false;
        this.isDataLoaded = true;

        return Promise.resolve();
    }

    public changeDataEvent(stepName: string, model: any, saveDataWeb?: boolean) {
        // Somente executa evento para nativo caso necessário (Default é false)

        if (!this.selectedTrack.isUncoupled() && this.selectedTrack.isEventComunicator()) {
            this.logService.save('Enviando obj nativo', 'JourneyService.changeDataEvent')
            this.logService.save(JSON.stringify(this.registratioJourney), 'JourneyService.changeDataEvent')
            this.cacheNativeService.setItemCommunicator(this.registratioJourney);
        }
    }

    public finishDataEvent() {
        if (this.selectedTrack.isUncoupled()) {
            localStorage.setItem('cache-native-v2', JSON.stringify(this.registratioJourney));
        }
        if (this.selectedTrack.isEventComunicator()) {
            this.cacheNativeService.setItemCommunicator(this.registratioJourney);
        }
    }

    public finishCustomDataEvent(params: object) {
        this.cacheNativeService.setItemCommunicator(params);
    }

    public getNextRoute(pageId: string): string[] {
        const selectedPage = this.selectedTrack.getTrack().find(r => r.pageId === pageId);
        const index = this.selectedTrack.getTrack().indexOf(selectedPage);
        const actionName = selectedPage?.parameters?.actionName;

        const actionResult = actionName ?
            this.selectedTrack.executeAction(actionName, this.registratioJourney.data) :
            selectedPage?.action ?
                selectedPage.action(this.registratioJourney.data, this.edit, this.selectedTrack.track) :
                undefined;
        
        if (actionResult) {
            this.registratioJourney.data = actionResult.data;

            if (actionResult.newTrack) {
                this.selectedTrack.track = actionResult.newTrack;
            }

            if (actionResult.nextRoute) {
                return actionResult.nextRoute.path;
            } else {
                if (this.selectedTrack.isUncoupled()) {
                    if (this.selectedTrack.isEventComunicator()) {
                        this.cacheNativeService.setItemCommunicator(this.registratioJourney);
                    }
                }
                return undefined;
            }
        } else {
            if (index < this.selectedTrack.getTrack().length - 1) {
                return this.selectedTrack.getTrack()[(index + 1)].path;
            } else {
                if (this.selectedTrack.isUncoupled()) {
                    if (this.selectedTrack.isEventComunicator()) {
                        this.cacheNativeService.setItemCommunicator(this.registratioJourney);
                    }
                }
                return undefined;
            }
        }

    }

    public getPreviousRoute(pageId: string): string[] {

        const selectedPage = this.selectedTrack.getTrack().find(r => r.pageId === pageId);
        const index = this.selectedTrack.getTrack().indexOf(selectedPage);

        if (index > 0) {
            return this.selectedTrack.getTrack()[(index - 1)].path;
        } else {
            return undefined;
        }

    }

    public getCurrentTrack(pageId: string): TrackInfo {
        return this.selectedTrack.getTrack().find(r => r.pageId === pageId);
    }
}
